import { AthleteHeroBackground } from "@/components/athlete/AthleteHeroBackground";
import { useThemeCustomization } from "@/hooks/useThemeCustomization";
import type { AthleteBackgroundKey } from "@/lib/athleteTheme";

interface AthleteBrandHeaderProps {
  title?: string;
  subtitle?: string;
  backgroundKey?: AthleteBackgroundKey;
  showLogo?: boolean;
}

export function AthleteBrandHeader({ title, subtitle, backgroundKey, showLogo = true }: AthleteBrandHeaderProps) {
  const { logoUrl, brandName, athleteBackgrounds } = useThemeCustomization();
  const backgroundUrl = backgroundKey ? athleteBackgrounds[backgroundKey] : undefined;

  return (
    <header className="athlete-brand-header athlete-brand-header--image">
      <AthleteHeroBackground src={backgroundUrl} />
      <div className="athlete-brand-header-overlay absolute inset-0" />
      <div className="relative z-10">
        {showLogo && logoUrl && <img src={logoUrl} alt={brandName} className="athlete-brand-logo" />}
        {title && <h1 className={`${showLogo ? "mt-5" : ""} text-3xl font-bold text-foreground md:text-4xl`}>{title}</h1>}
        {title && <div className="mt-1.5 h-0.5 w-16 bg-primary" aria-hidden="true" />}
        {subtitle && <p className="mt-1 max-w-xl text-sm text-muted-foreground md:text-base">{subtitle}</p>}
      </div>
    </header>
  );
}